import axios from 'axios';

// Backend API base. Set REACT_APP_BACKEND_URL in .env (e.g. https://smdapi.navyaclothingo.com/public for production)
export const API_BASE = process.env.REACT_APP_BACKEND_URL || 'https://smdapi.navyaclothingo.com/public';

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  // API_BASE is exported above for building asset URLs
  headers: {
    'Content-Type': 'application/json',
  },
});

// Fix URL: axios drops baseURL path when url starts with /. Strip leading slash
// so baseURL + url = http://localhost:8080/api + auth/login = http://localhost:8080/api/auth/login
api.interceptors.request.use(
  (config) => {
    if (config.url && config.url.startsWith('/')) {
      config.url = config.url.slice(1);
    }
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle auth errors (don't redirect if the failed request was login - we're already on login page)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/auth/login');
      if (!isLoginRequest) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/** Build full URL for school asset (logo, etc.) stored as assets/school/{id}/filename */
export function getSchoolAssetUrl(logo, schoolId) {
  if (!logo) return null;
  if (String(logo).startsWith('http')) return logo;
  const m = String(logo).match(/assets\/school\/(\d+)\/(.+)/);
  const id = m ? m[1] : (schoolId ?? '');
  const file = m ? m[2] : logo;
  if (!id || !file) return null;
  return `${API_BASE}/api/assets/school/${id}/${file}`;
}

/**
 * Build full URL for student/teacher profile photo stored as
 * assets/school/{schoolId}/student/{studentId}/filename or
 * assets/school/{schoolId}/teacher/{teacherId}/filename
 */
export function getProfileAssetUrl(avatar) {
  if (!avatar) return null;
  if (String(avatar).startsWith('http')) return avatar;
  const studentMatch = String(avatar).match(/assets\/school\/(\d+)\/student\/(\d+)\/(.+)/);
  if (studentMatch) {
    return `${API_BASE}/api/assets/school/${studentMatch[1]}/student/${studentMatch[2]}/${studentMatch[3]}`;
  }
  const teacherMatch = String(avatar).match(/assets\/school\/(\d+)\/teacher\/(\d+)\/(.+)/);
  if (teacherMatch) {
    return `${API_BASE}/api/assets/school/${teacherMatch[1]}/teacher/${teacherMatch[2]}/${teacherMatch[3]}`;
  }
  return null;
}

export default api;
